import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { TypographyProps } from '@material-ui/core/Typography';
import Small from './Small';

const Title: React.FC<TypographyProps> = withStyles((theme) => ({
  root: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    height: `calc(${theme.typography.pxToRem(12)} * ${
      theme.typography.body1.lineHeight
    } * 2)`,
    [theme.breakpoints.up('sm')]: {
      height: `calc(${theme.typography.pxToRem(14)} * ${
        theme.typography.body1.lineHeight
      } * 2)`,
    },
  },
}))(Small);

export default Title;
